import api from '@/api';
import { ForexHistoryFilter, ForexHistoryItem } from '@/feature/TrHistory/api/forex-history.interface';
import { mapForexHistoryList } from '@/feature/TrHistory/api/forex-history.utils';
import jsFileDownload from 'js-file-download';
import { getEnumKeyByValue } from '@/modules/Enum/enum-utils';
import { FileMimeByExt } from '@/components/IBFile/interface';
import { DateUtils } from '@/modules/DateCore/DateUtils';
import { wrapAutoCancellableLast } from '@/api/core/cancellable';
import NotificationCore from "@/modules/NotificationCore/NotificationCore";

function getNowDate(): string {
	const date = new Date();
	let y: number | string = date.getFullYear();
	let m: number | string = date.getMonth() + 1;
	let i: number | string = date.getDate();
	
	if (m < 10) m = '0' + m;
	if (i < 10) i = '0' + i;
	
	return `${y}-${m}-${i}`;
}

export const $downloadForexHistory = (
	history: ForexHistoryItem
): Promise<void> => api
	.get('foreign-exchange/download/' + history.foreignExchangeId, {
		request: { responseType: 'blob' },
		handler: { returnData: false, skipChecking: true }
	})
	.then(async (response: Blob) => {
		const dateTime: string = DateUtils
			.getFormattedDateTime(new Date())
			.replace(/\:/g, '-');

		const filename: string = `${history.foreignExchangeId}-${dateTime}`;
		const ext: string = '.' + getEnumKeyByValue(FileMimeByExt, response.type as FileMimeByExt);

		if (response.type === FileMimeByExt.pdf) {
			jsFileDownload(response, filename + ext);
		} else {
			const text = await response.text();
			const error = JSON.parse(text);
			NotificationCore.addToast(error.errorMessage, 'error');
		}
	});

export const $getForexHistoryList = async (
	filter?: ForexHistoryFilter
): Promise<ForexHistoryItem[]> => {
	if (!filter.fromOperDay) {
		filter.fromOperDay = getNowDate();
		filter.toOperDay = getNowDate();
	}

	return api
		.post('foreign-exchange/list', filter, {
			handler: { disableLoader: true }
		})
		.then(response => mapForexHistoryList(response?.data));
};

export const $getForexHistoryListOnce = wrapAutoCancellableLast(
	$getForexHistoryList,
	mapForexHistoryList
);
